import { render, staticRenderFns } from "./coursesDetails.vue?vue&type=template&id=5785bd96"
import script from "./coursesDetails.vue?vue&type=script&lang=js"
export * from "./coursesDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports